module.exports = __webpack_public_path__ + "img/office-2.6d8d6aae.webp";